module.exports = __webpack_public_path__ + "static/insured-tickets-d4a0ea7f12771dde0c25d30f51f33804.png";